<template>
  <div v-if="isLoginUserPageUserWritable">

    <userTabs v-if="!presentationMode" :current="'map'" :pageUser="pageUser">
      <span class="displayNoneMax630 narrowText2">
        확대: {{this.locationZoom}}, 글자: {{this.mapFontSize}}
      </span>
      <b-button variant="primary" size="sm" @click="saveUiDeviceMap" v-if="this.isLoginUserPageUser" class="tabButton mr-1 ml-2" v-b-tooltip.hover.top title="현재 지도 확대 정도와 글자 크기를 저장합니다.">
        저장
      </b-button>
      <b-button variant="secondary" size="sm" @click="removeUiDeviceMap" v-if="this.isLoginUserPageUser && this.pageUser.ui_devicemap_location != null" class="tabButton mr-2" v-b-tooltip.hover.top title="저장된 설정을 삭제합니다.">
        삭제
      </b-button>
    </userTabs>

    <div class="mt-2 mb-2" v-touch:swipe.stop>
      <GmapMap ref="gmap" v-if="isLoginUserPageUser" :center="{ 'lat': 37.545576, 'lng': 126.959690 }" :zoom="locationZoom" class="no-select" style="width: 100%; height: 0; padding-bottom: 80%;" :options="{
        mapTypeControl: true,
        mapTypeControlOptions: { style: 2, position: 1 },
        fullscreenControl: true,
        fullscreenControlOptions: { position: 7 },
        zoomControl: true,
        zoomControlOptions: { position: 7 },
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        disableDefaultUi: false,
        gestureHandling: 'auto'
      }"></GmapMap>

      <div id="gmapTextSize" style="visibility: hidden" class="map-block map-textsize-block">
        <div class="map-textsizeplus-text noSelect" @click="mapTextSizePlus" v-b-tooltip.hover.left title="글자 크기를 크게">T+</div>
        <hr/>
        <div class="map-textsizeminus-text roboto noSelect" @click="mapTextSizeMinus" v-b-tooltip.hover.left title="글자 크기를 작게">T-</div>
      </div>

      <div id="gmapInit" style="visibility: hidden" class="mt-2 map-block map-center-block">
        <div class="map-center-text roboto noSelect" @click="mapInit" v-b-tooltip.hover.left title="저장된 설정으로 초기화">
          <img src="@/assets/img/init.svg" class="mb-1" style="width:80%;"/>
        </div>
      </div>

      <div id="gmapViewAll" style="visibility: hidden" class="mt-2 map-block map-center-block">
        <div class="map-center-text roboto noSelect" @click="mapViewAll" v-b-tooltip.hover.left title="모든 기기를 한 화면에 보기">
          <img src="@/assets/img/fullsize.svg" class="mb-1" style="width:80%;"/>
        </div>
      </div>

      <div id="gmapDeviceList" v-if="mapDevices != null">
        <b-form-select v-model="selectedDevice" style="word-spacing: -1px;" id="gmapDeviceListSelect" @change="mapShowSelected">
          <option v-for="device in this.mapDevices" :value="device.obj.id" :key="device.obj.id">
            {{ device.obj.name }}
            <span v-if="device.obj.locationInfo != null && typeof(device.obj.locationInfo.name) != 'undefined'">,
              {{ device.obj.locationInfo.name }}
            </span>
            <span v-if="device.obj.admin == loginUser.id">,
              @admin
            </span>
          </option>
        </b-form-select>
      </div>

      <div v-if="mapDevices != null">
        <div class="map-popup-block" v-for="device in mapDevices" :id="`popup${device.obj.id}`" style="visibility: hidden" :key="device.obj.id">
          <div class="map-popup-body">
            <div class="map-popup-title gothic no-select narrowText2" :class="device.collapsed ? 'collapsed' : null" :aria-expanded="device.collapsed ? 'true' : 'false'" :aria-controls="`table${device.obj.id}`" @click="toggleDeviceTable(device.obj.id)">
              <span v-if="device.obj.admin == loginUser.id" class="float-right text-blue-light">@admin</span>
              {{device.obj.name}}
            </div>
            <b-collapse class="map-popup-collapse" :id="`table${device.obj.id}`" v-model="device.collapsed" @click="bringToTop(device.obj.id)">
              <div class="map-popup-content">
                <div v-for="sensor in device.obj.sensors"  :key="sensor.id">
                  <div v-if="sensor.lastValues != null">
                    <div v-for="(value, index) in sensor.values.filter(item => item.hold !== true)" :key="index" class="map-popup-row d-flex flex-nowrap justify-content-between">
                      <div class="text-left map-popup-row-title narrowText2 mr-auto flex-grow-1">
                        {{ value.title }}
                      </div>
                      <div class="map-popup-row-value">
                        {{ sensor.lastValues.v[index].toLocaleString('ko-KR') }}
                      </div>
                      <div class="map-popup-row-unit gothic narrowText2" v-if="value.unit">
                        {{ value.unit }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
          <div class="map-popup-marker">
            <img src="@/assets/img/mapMarker2.png" @click="clickMarker(key)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import uiUtil from "@/mixins/util.js";
import mapUtil from "@/mixins/mapUtil.js";
import user from "@/mixins/user.js";
import { gmapApi } from "gmap-vue";

import userTabs from "@/components/user/userTabs.vue"

import { mapActions } from "vuex"
import { mapState } from "vuex"
import { mapSetter } from "@/plugins/vuexUtils.js"

export default {
  name: "deviceMap",
  mixins: [uiUtil, mapUtil, user],
  props: {
    pageBinded: {
      type: Boolean,
      default: false
    },
    pageUser: {
      type: Object,
      default: null
    },
    uid: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      default: ""
    },
  },
  components: {
    userTabs,
  },
  data: function() {
    return {
      mapDevices: null,
      currentDevice: null,
      selectedDevice: null,
      locationZoom: 13,
      lcationCenter: null,
      mapFontSize: 14,
      locationViewport: {},
    }
  },
  async mounted() {

    if(!this.isLoginUserPageUser) {
      this.$router.push({ path: "/u/" + this.pageUser.id + "?mode=list&marker=" + this.marker })
      return
    }

    this.initMapDevices();
    this.$log.debug(this.mapDevices);

    await this.$gmapApiPromiseLazy();

    /* eslint-disable */
    this.$refs.gmap.$mapPromise.then((map) => {

      this.$refs.gmap.$mapObject.controls[google.maps.ControlPosition.RIGHT_TOP].push(window.document.getElementById("gmapTextSize"));
      this.$refs.gmap.$mapObject.controls[google.maps.ControlPosition.RIGHT_TOP].push(window.document.getElementById("gmapViewAll"));
      this.$refs.gmap.$mapObject.controls[google.maps.ControlPosition.RIGHT_TOP].push(window.document.getElementById("gmapInit"));
      this.$refs.gmap.$mapObject.controls[google.maps.ControlPosition.TOP_LEFT].push(window.document.getElementById("gmapDeviceList"));

      let gmapPopupClass = this.createPopupClass();

      this.locationViewport = {};
      this.locationViewport.deviceLatMax = -90;
      this.locationViewport.deviceLatMin = 90;
      this.locationViewport.deviceLngMax = -180;
      this.locationViewport.deviceLngMin = 180;

      for(let item in this.mapDevices) {
        this.mapDevices[item].popup = new gmapPopupClass(new google.maps.LatLng(this.mapDevices[item].obj.location.latitude, this.mapDevices[item].obj.location.longitude),"popup" + item);

        if(this.mapDevices[item].obj.location.latitude > this.locationViewport.deviceLatMax) {
          this.locationViewport.deviceLatMax = this.mapDevices[item].obj.location.latitude;
        }
        if(this.mapDevices[item].obj.location.latitude < this.locationViewport.deviceLatMin) {
          this.locationViewport.deviceLatMin = this.mapDevices[item].obj.location.latitude;
        }
        if(this.mapDevices[item].obj.location.longitude > this.locationViewport.deviceLngMax) {
          this.locationViewport.deviceLngMax = this.mapDevices[item].obj.location.longitude;
        }
        if(this.mapDevices[item].obj.location.longitude < this.locationViewport.deviceLngMin) {
          this.locationViewport.deviceLngMin = this.mapDevices[item].obj.location.longitude;
        }

        if(typeof(this.pageUser.ui_devicemap_location) != "undefined" && this.pageUser.ui_devicemap_location != null && typeof(this.pageUser.ui_devicemap_popupFontSize) != "undefined" && this.pageUser.ui_devicemap_popupFontSize != 0) {
          window.document.getElementById('popup' + item).style.fontSize = this.pageUser.ui_devicemap_popupFontSize + "px";
        }

        this.mapDevices[item].popup.setMap(map);
        window.document.getElementById("popup" + item).style.display = "block";
        window.document.getElementById("popup" + item).style.visibility = "visible";

      }

      if(typeof(this.pageUser.ui_devicemap_location) != "undefined" && this.pageUser.ui_devicemap_location != null) {
        this.locationCenter = this.toLatLng(this.pageUser.ui_devicemap_location);
        map.setCenter(this.locationCenter);
        if(typeof(this.pageUser.ui_devicemap_zoom) != "undefined" && this.pageUser.ui_devicemap_zoom != 0) {
          this.locationZoom = this.pageUser.ui_devicemap_zoom;
          map.setZoom(this.pageUser.ui_devicemap_zoom);
          window.document.getElementById("gmapInit").style.display = "block";
        }
      }
      else {
        this.locationCenter = new google.maps.LatLng((this.locationViewport.deviceLatMax+this.locationViewport.deviceLatMin)/2, (this.locationViewport.deviceLngMax + this.locationViewport.deviceLngMin)/2)
        map.setCenter(this.locationCenter)
        let verticalDistance = google.maps.geometry.spherical.computeDistanceBetween(this.locationCenter, new google.maps.LatLng(this.locationViewport.deviceLatMax + 0.3*(this.locationViewport.deviceLatMax-this.locationViewport.deviceLatMin), (this.locationViewport.deviceLngMax + this.locationViewport.deviceLngMin)/2))
        let horizontalDistance = google.maps.geometry.spherical.computeDistanceBetween(this.locationCenter, new google.maps.LatLng((this.locationViewport.deviceLatMax+this.locationViewport.deviceLatMax)/2, this.locationViewport.deviceLngMax + 0.1*(this.locationViewport.deviceLngMax-this.locationViewport.deviceLngMin)))
        let verticalZoom = Math.log(156543.03392 * Math.cos(this.locationCenter.lat() * Math.PI / 180) / (verticalDistance*2/(map.getDiv().offsetHeight))) / Math.log(2);
        let horizontalZoom = Math.log(156543.03392 * Math.cos(this.locationCenter.lat() * Math.PI / 180) / (horizontalDistance*2/map.getDiv().offsetWidth)) / Math.log(2);
        if(isFinite(verticalZoom)&&isFinite(horizontalZoom)) {
          this.locationZoom = Math.floor(Math.min(verticalZoom, horizontalZoom));
        }
        window.document.getElementById("gmapInit").style.display = "none";
      }

      window.document.getElementById("gmapInit").style.visibiliy = "visible";
      window.document.getElementById("gmapTextSize").style.visibiliy = "visible";
      window.document.getElementById("gmapViewAll").style.visibiliy = "visible";
      window.document.getElementById("gmapDeviceList").style.visibiliy = "visible";

      for(let item in this.mapDevices) {
        if(this.mapDevices[item].active) {
          window.document.getElementById("popup" + item).classList.add("map-popup-block-active");
        }
      }
      if(this.marker != "" && typeof(this.mapDevices[this.marker]) != "undefined") {
        this.clickMarker(this.marker)
      }
    }).catch((error)=> {
      this.$log.error(error)
    })
  },
  /* eslint-enable */
  computed: {
    ...mapSetter(
      mapState({
        loginUser: state => state.loginUser,
      })
    ),
    google: gmapApi
  },

  methods: {

    initMapDevices: function() {
      let result = {};
      ((this.isLoginUserPageUser&&this.loginUserDeepBinding)? this.loginUserDeviceArrayAll : this.pageUserDeviceArrayAll).filter(item=>{
        return item.location != null && typeof(item.deleteScheduledTime) == "undefined"
      }).forEach(device => {
        result[device.id] = {
          "active": ((device.disabled) != "undefined" && device.disabled)? false : device.active,
          "collapsed": (this.countAttributes(device.sensors) != 0 && device.active && !device.disabled )? true: false,
          "obj": device
        }
      })
      this.$set(this, "mapDevices", result);
    },

    bringToTop: function(key) {
      for(let item in this.mapDevices) {
        window.document.getElementById("popup" + item).style.zIndex = (item == key) ? 3000: 1000
      }
    },
    setToSelected(key) {
      if(this.currentDevice != null) {
        window.document.getElementById("popup" + this.currentDevice).classList.remove("map-popup-block-selected")
      }
      this.currentDevice = key
      this.selectedDevice = key
      window.document.getElementById("popup" + this.currentDevice).classList.add("map-popup-block-selected")
    },
    mapShowSelected: function() {
      if(this.selectedDevice != this.currentDevice) {
        this.bringToTop(this.selectedDevice)
        this.setToSelected(this.selectedDevice)
      }
      if(!this.isInsideViewport(this.$refs.gmap.$mapObject, this.mapDevices[this.selectedDevice].popup.position)) {
        this.$refs.gmap.$mapObject.setCenter(this.mapDevices[this.selectedDevice].popup.position)
      }
    },
    clickMarker: function(key) {
      this.bringToTop(key)
      this.setToSelected(key)
      this.$refs.gmap.$mapObject.setCenter(this.mapDevices[key].popup.position)
    },
    mapTextSizePlus: function() {
      let updated = false
      for(let item in this.mapDevices) {
        if(!updated) {
          this.mapFontSize = parseInt(window.getComputedStyle(window.document.getElementById('popup' + item)).fontSize) + 1
          this.$log.debug("mapFontSize:", this.mapFontSize);
          if(this.mapFontSize >= 30) return
        }
        this.$log.debug(window.document.getElementById('popup' + item).style.fontSize);
        window.document.getElementById('popup' + item).style.fontSize = this.mapFontSize + "px"
        this.$log.debug(window.document.getElementById('popup' + item).style.fontSize);
      }
    },
    mapTextSizeMinus: function() {
      let updated = false
      for(let item in this.mapDevices) {
        if(!updated) {
          this.mapFontSize = parseInt(window.getComputedStyle(window.document.getElementById('popup' + item)).fontSize) - 1
          if(this.mapFontSize <= 8) return
        }
        window.document.getElementById('popup' + item).style.fontSize = this.mapFontSize + "px"
      }
    },
    mapViewAll: function() {
      // eslint-disable-next-line
      let centerPosition = new google.maps.LatLng((this.locationViewport.deviceLatMax+this.locationViewport.deviceLatMin)/2, (this.locationViewport.deviceLngMax + this.locationViewport.deviceLngMin)/2)
      this.$refs.gmap.$mapObject.setCenter(centerPosition)
      // eslint-disable-next-line
      let verticalDistance = google.maps.geometry.spherical.computeDistanceBetween(centerPosition, new google.maps.LatLng(this.locationViewport.deviceLatMax + 0.3*(this.locationViewport.deviceLatMax-this.locationViewport.deviceLatMin), (this.locationViewport.deviceLngMax + this.locationViewport.deviceLngMin)/2))
      // eslint-disable-next-line
      let horizontalDistance = google.maps.geometry.spherical.computeDistanceBetween(centerPosition, new google.maps.LatLng((this.locationViewport.deviceLatMax+this.locationViewport.deviceLatMax)/2, this.locationViewport.deviceLngMax + 0.1*(this.locationViewport.deviceLngMax-this.locationViewport.deviceLngMin)))
      let verticalZoom = Math.log(156543.03392 * Math.cos(centerPosition.lat() * Math.PI / 180) / (verticalDistance*2/(this.$refs.gmap.$mapObject.getDiv().offsetHeight))) / Math.log(2)
      let horizontalZoom = Math.log(156543.03392 * Math.cos(centerPosition.lat() * Math.PI / 180) / (horizontalDistance*2/this.$refs.gmap.$mapObject.getDiv().offsetWidth)) / Math.log(2)
      this.$refs.gmap.$mapObject.setZoom(Math.floor(Math.min(verticalZoom, horizontalZoom)))
    },
    mapInit: function() {
      this.$refs.gmap.$mapObject.setCenter(this.locationCenter)
      for(let item in this.mapDevices) {
        if(typeof(this.pageUser.ui_devicemap_location) != "undefined" && this.pageUser.ui_devicemap_location != null) {
          if(typeof(this.pageUser.ui_devicemap_popupFontSize) != "undefined" && this.pageUser.ui_devicemap_popupFontSize != 0) {
            window.document.getElementById('popup' + item).style.fontSize = this.pageUser.ui_devicemap_popupFontSize + "px"
          }
        }
      }
      this.$refs.gmap.$mapObject.setZoom(this.locationZoom)
    },
    toggleDeviceTable: function(key) {
      if(key != this.currentDevice) {
        this.bringToTop(key)
        this.setToSelected(key)
      }
      else {
        if(this.mapDevices[key].collapsed) {
          window.document.getElementById('table' + key).style.display = "block"
          this.mapDevices[key].collapsed = false
        }
        else {
          window.document.getElementById('table' + key).style.display = "none"
          this.mapDevices[key].collapsed = true
        }
      }
    },
    saveUiDeviceMap: function() {
      if(this.isLoginUserPageUser) {

      }
      this.pageUser.ui_devicemap_location = this.toGeoPoint(this.$refs.gmap.$mapObject.getCenter())
      this.pageUser.ui_devicemap_zoom = this.$refs.gmap.$mapObject.getZoom()
      this.pageUser.ui_devicemap_popupFontSize = this.mapFontSize

      this.storeSaveUiDeviceMap(this.pageUser).then(() => {
        this.makeToast("success", "지도 설정 저장 성공", "지도 설정을 저장했습니다. 현재 지도의 중심, 줌인 정도, 팝업 글자 크기가 자동 적용됩니다.")
        window.document.getElementById("gmapInit").style.display = "block"
        this.locationCenter = this.toLatLng(this.pageUser.ui_devicemap_location)
        this.locationZoom = this.pageUser.ui_devicemap_zoom
      }).catch((error)=> {
        this.$log.error(error)
      })
    },
    removeUiDeviceMap: function() {
      this.pageUser.ui_devicemap_location = null
      this.pageUser.ui_devicemap_zoom = 0
      this.pageUser.ui_devicemap_popupFontSize = 0
      this.storeRemoveUiDeviceMap(this.pageUser).then( ()=> {
        this.makeToast("success", "지도 설정 삭제 성공", "지도 설정을 삭제했습니다. 전체 기기를 모두 볼 수 있도록 지도의 중심과 줌인 정도가 자동 조절됩니다.")
        this.pageUser.ui_devicemap_zoom = 13
        this.pageUser.ui_devicemap_popupFontSize = 14
        window.document.getElementById("gmapInit").style.display = "none"
        this.mapViewAll()
      }).catch((error)=> {
        this.$log.error(error)
      })
    },
    ...mapActions(['storeSaveUiDeviceMap', 'storeRemoveUiDeviceMap']),
  },

}
</script>
